'use client';
import Link from "next/link";
import Image from "next/image";
import { toast } from 'sonner';
import {useRouter} from "next/navigation";
import { z } from "zod";
import {useState} from "react";

const registerSchema = z.object({
    name: z.string().optional(),
    username: z.string({required_error: "Missing username"}).min(6, {message: 'Username must be at least 6 characters long'}).max(32, {message: 'Username must be at most 32 characters long'}),
    email: z.string({required_error: "Missing email"}).email({message: 'Invalid email address'}),
    password: z.string({required_error: "Missing password"}).min(8, {message: 'Password must be at least 8 characters long'}).max(32),
});

export default function Register() {
    const router = useRouter();
    const [form, setForm] = useState({});

    const register = (e) => {
        e.preventDefault();
        try {
            registerSchema.parse(form);
            const users = JSON.parse(localStorage.getItem('users_register')) || [];
            users.push(form);
            localStorage.setItem('users_register', JSON.stringify(users));
            toast.success('Account created successfully');
            router.push('/dashboard/learn');
        } catch (error) {
            const id = error.issues[0].path[0];
            document.getElementById(id).focus();
            error.issues.reverse().forEach((issue) => {
                toast.error(issue.message);
            });
        }
    }

    const useSocial = (e) => {
        e.preventDefault();
        toast.success('Created account using social media');
        router.push('/dashboard/learn');
    }

    const handleChange = (e) => {
        setForm((prev) => ({...prev, [e.target.id]: e.target.value}));
    }

    return (
        <main className="min-h-screen flex items-center justify-center">
            <div className="absolute left-7	top-7">
                <Link href="/">
                    <Image alt="Close icon" src="img/close.svg" width="16" height="16" />
                </Link>
            </div>
            <div className="w-24 absolute right-7 top-7">
                <Link href="/login" className="flex hover:bg-gray-100 h-12 rounded-xl items-center justify-center border-2 border-b-4 border-zinc-50 w-full">
                    <span className="uppercase font-extrabold text-sm text-yellow-500">Login</span>
                </Link>
            </div>
            <form className="w-96 text-center">
                <div>
                    <h1 className="font-extrabold text-2xl mb-8">Create your profile</h1>
                    <div className="flex flex-col text-2xl text-start w-full gap-4">
                        <input type="text" id="name" onChange={handleChange} placeholder="Name (optional)" className="form-field-register"/>
                        <input type="text" id="username" onChange={handleChange} placeholder="Username" className="form-field-register"/>
                        <input type="text" id="email" onChange={handleChange} placeholder="Email" className="form-field-register"/>
                        <input type="password" id="password" onChange={handleChange} placeholder="Password" className="form-field-register"/>
                    </div>
                    <button onClick={register} className="auth-button">
                        <span className="uppercase tracking-wide font-bold text-white">Create account</span>
                    </button>
                    <div className="my-5 flex items-center justify-center">
                        <div className="bg-gray-300 h-0.5 flex-grow"></div>
                        <div className="uppercase text-base text-gray-400 font-bold flex-grow-0 px-2">or</div>
                        <div className="bg-gray-300 h-0.5 flex-grow"></div>
                    </div>
                    <p className="flex gap-4 w-full justify-center">
                        <button onClick={useSocial} className="form-social-button">
                            <Image src="img/facebook.svg" alt="Facebook logo" className="mr-2.5" width={16} height={32} />
                            <span className="uppercase font-extrabold text-sm text-blue-600">Facebook</span>
                        </button>
                        <button onClick={useSocial} className="form-social-button">
                            <Image src="img/google.svg" alt="Google logo" className="mr-2.5" width={30} height={30} />
                            <span className="uppercase font-extrabold text-sm text-blue-500">Google</span>
                        </button>
                    </p>
                </div>
                <div className="pt-10">
                    <span className="text-base text-gray-400">
                        By signing in MeowLingo, you agree to&nbsp;
                        <Link href="/terms" className="font-bold">Terms</Link> and&nbsp;
                        <Link href="/privacy" className="font-bold">Privacy Policy</Link>.
                    </span>
                </div>
            </form>
        </main>
    );
}
